import { useEffect, useState } from 'react';
import { captureException } from '@sentry/react';
import { AxiosResponse } from 'axios';

import { authorizedAxiosInstance } from '@/clients';
import { GitHubLatestRelease } from '@/types';

export const useLatestRelease = () => {
    const [latestRelease, setLatestRelease] = useState<Partial<GitHubLatestRelease>>({});
    const [latesReleaseLoading, setLatesReleaseLoading] = useState<boolean>(true);

    const handleFetchLatestReleases = async () => {
        try {
            setLatesReleaseLoading(true);

            await authorizedAxiosInstance.get('/api/system/release').then((res: AxiosResponse) => {
                if (res?.status === 200) {
                    setLatestRelease(res.data as GitHubLatestRelease);

                    setLatesReleaseLoading(false);
                }
            });
        } catch (error) {
            captureException(error);
        } finally {
            setLatesReleaseLoading(false);
        }
    };

    const [buildSize, setBuildSize] = useState();
    const [buildSizeLoading, setBuildSizeLoading] = useState(true);

    // const handleGetMostRecentBuildSize = async () => {
    //     try {
    //         setBuildSizeLoading(true);

    //         await authorizedAxiosInstance
    //             .get('/api/system/build')
    //             .then((res: AxiosResponse) => {
    //                 if (res?.status === 200) {
    //                     setBuildSize(res?.data?.sizeMB);

    //                         setBuildSizeLoading(false);

    //                 }
    //             });
    //     } catch (error) {
    //         captureException(error);
    //     }
    // };

    useEffect(() => {
        setLatesReleaseLoading(false);

        handleFetchLatestReleases();
    }, []);

    return { latesReleaseLoading, latestRelease };
};
